/** Nome, e-mail e código da turma extraídos do `value` da matrícula. */
export interface ParsedStudentEnrollment {
  readonly name: string;
  readonly email: string;
  readonly classCode: string;
}

/**
 * Faz o parse do `value` de `DropDownListStringKeyViewModel` retornado por
 * `GET /api/v1/person/shared/student-enrollments`, no formato
 * `"Nome [Email] Código da Turma"`.
 *
 * Tolerante a formatos fora do padrão: quando não há colchetes de e-mail, todo o texto
 * vira o `name` e os demais campos ficam vazios.
 *
 * @param value - String combinada devolvida pelo backend (`null`/`undefined` → tudo vazio).
 * @returns `{ name, email, classCode }` com os trechos separados e sem espaços nas pontas.
 *
 * @example
 * ```ts
 * parseStudentEnrollment('Maria Silva [maria@aluno.mbx] T-102');
 * // { name: 'Maria Silva', email: 'maria@aluno.mbx', classCode: 'T-102' }
 * ```
 */
export function parseStudentEnrollment(value: string | null | undefined): ParsedStudentEnrollment {
  const raw = (value ?? '').trim();
  const match = raw.match(/^(.*?)\s*\[([^\]]*)\]\s*(.*)$/);

  if (!match) {
    return { name: raw, email: '', classCode: '' };
  }

  return {
    name: (match[1] ?? '').trim(),
    email: (match[2] ?? '').trim(),
    classCode: (match[3] ?? '').trim(),
  };
}
